import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Eye, Zap } from 'lucide-react';
import MiniAngelScene from './MiniAngelScene';

export default function AboutSection() {
  return (
    <section id="about" className="section-padding relative" data-testid="about-section">
      <div className="section-divider mb-24" />
      <div className="hidden lg:block absolute top-24 right-8 z-0"><MiniAngelScene type="wing" size={200} /></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-24">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-1"
          >
            <p className="font-mono text-xs tracking-[0.3em] text-white/30 uppercase mb-4">Process</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl">
              HOW WE
              <br />
              <span className="text-white/25">CREATE</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-2 space-y-12"
          >
            {[
              {
                icon: Eye,
                step: '01',
                title: 'VISION',
                description: 'We immerse ourselves in your brand. Understanding your market, your audience, and the feeling you want to evoke. This isn\'t a brief — it\'s a deep dive into your world.',
              },
              {
                icon: Zap,
                step: '02',
                title: 'CREATION',
                description: 'Our AI-human hybrid pipeline generates concepts at machine speed with human taste. We iterate rapidly, refining until every polygon and every pixel serves the vision.',
              },
              {
                icon: Shield,
                step: '03',
                title: 'DELIVERY',
                description: 'Production-ready assets, optimized for any platform. Web, social, broadcast, VR — delivered with technical precision and creative excellence.',
              },
            ].map((item, i) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={item.step}
                  initial={{ opacity: 0, x: 40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15, duration: 0.6 }}
                  className="flex gap-8 group"
                  data-testid={`process-step-${item.step}`}
                >
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 border border-white/10 flex items-center justify-center group-hover:border-white/30 transition-colors duration-500">
                      <Icon size={22} strokeWidth={1.5} className="text-white/40 group-hover:text-white/80 transition-colors duration-500" />
                    </div>
                  </div>
                  <div>
                    <p className="font-mono text-xs text-white/20 mb-2">{item.step}</p>
                    <h3 className="font-heading text-xl mb-3">{item.title}</h3>
                    <p className="text-white/30 text-sm leading-relaxed">{item.description}</p>
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
